// 采购单列表
import request from "@/utils/request";

export function fetchList(params) {
	return request({
		url: '/scm/goods/demand/problemDemandList',
		method: 'post',
		data: params
	})
}

// 标记问题单
export function mark(data) {
	return request({
		url: '/scm/goods/demand/problemDemand/oos',
		method: 'post',
		data
	})
}

// 重新采购
export function repurchase(data) {
	return request({
		url: '/scm/goods/demand/problemDemand/repurchase',
		method: 'post',
		data
	})
}

// 修改采购链接
export function editPurchaseLink(data) {
	return request({
		url: '/scm/goods/demand/updatePurchaseLink',
		method: 'post',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/pcm/unable-purchase.js